import React from 'react';
import RouteBuilder from './router/RouteBuilder';
import Navigation from './ui/Navigation';

import './css/App.scss';
import './css/Responsive.scss';
import Footer from './ui/Footer';
import { History } from './router/History';
// import BlurredContent from './ui/BlurredContent';
import Router from './router/Router';
import GridLines from './ui/GridLines';
import SVGFixer from './core/SVGFixer';
import Background, { BackgroundEvent } from './ui/Background';
import Loading from './ui/Loading';
import Content from './core/Content';
import ObjectUtils from './utils/ObjectUtils';


export default class App extends React.Component {
	// resolveURL('');
	state = {content:null, background: null};
	container = React.createRef<HTMLDivElement>();
	background:Background;
	loading:Loading;
	componentDidMount()
	{
		SVGFixer.init();
		this.loadData();
		window.addEventListener('load', this._loaded);
	}

	private async loadData()
	{
		if(!this.state.content)
		{
			let response;
			if ((response = await fetch('data/content.json')))
			{
				let data = await response.json();
				let externalItems = ObjectUtils.findAll(data, '_external', true);
				for(let o of externalItems)
				{
					try{
						if ((response = await fetch(o['_external'])))
						{
							o['_external'] = null;
							delete o['_external'];
							Object.assign(o, await response.json());
						}
					}catch
					{

					}
				}


				ObjectUtils.replaceInternals(data);
				console.log(data);
				Router.init(data['routes']);
				this.background = new Background(data);
				
				this.background.on(BackgroundEvent.CHANGE, this._backgroundChange);

				Content.setContent(data);
				this.setState({ content: data, background: this.background.currentBG});
			}else{

			}
		}
	}

	private _loaded = (e) => {
		this.loading.loaded();
		window.removeEventListener('load', this._loaded);
	}

	private _change = () => 
	{
		this.setState({background: this.background.currentBG});
	}

	_backgroundChange = (e) =>
	{
		// this.setState({background: this.background.currentBG});
	}

	render()
	{
		let bg = {};
		if(this.state.background)
		{
			bg = {backgroundImage: 'url(' + this.state.background + ')'};
		}
		return (
			<React.Fragment>
				<div ref={this.container} className='App' style={bg}>
					{
						(this.state.content)? (
							<RouteBuilder content={this.state.content} onChange={this._change}>
								<Footer data={this.state.content.footer}></Footer>
								<GridLines></GridLines>
								<Navigation data={this.state.content.menu}></Navigation>
							</RouteBuilder>
						): null
					}
				</div>
				<Loading ref={r => this.loading = r}></Loading>
				{/* <div className='pageMask'></div> */}
			</React.Fragment>

		);
	}
}

function Test(props:{path})
{
	return (<div></div>)
}
